import { Navigate } from 'react-router-dom';

/**
 * Redirect component for SEO-friendly redirects
 * Uses Navigate for client-side redirects with replace to avoid history pollution
 * @param {string} to - The destination URL (required)
 */
const Redirect = ({ to }) => {
  if (!to || typeof to !== 'string') {
    console.error('Redirect component requires a valid "to" prop');
    return null;
  }

  return <Navigate to={to} replace />;
};

export default Redirect;
